export default "__VITE_ASSET___2cEe2iz__"